import { createSlice } from "@reduxjs/toolkit";
import { exportProjectManagerTasksCSV, fetchProjectManagerTaksList } from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  exportCSVLoading: boolean;
  exportCSVError: string | null;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
  exportCSVLoading: false,
  exportCSVError: null,
};

const ProjectManageTaksListSlice = createSlice({
  name: "ProjectManagerTaksList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectManagerTaksList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectManagerTaksList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.list || [];
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProjectManagerTaksList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch ProjectManager Manpower Allocation List";
      })
      // CSV Export cases
      .addCase(exportProjectManagerTasksCSV.pending, (state) => {
        state.exportCSVLoading = true;
        state.exportCSVError = null;
      })
      .addCase(exportProjectManagerTasksCSV.fulfilled, (state) => {
        state.exportCSVLoading = false;
        state.exportCSVError = null;
      })
      .addCase(exportProjectManagerTasksCSV.rejected, (state, action) => {
        state.exportCSVLoading = false;
        state.exportCSVError =
          typeof action.payload === "string" ? action.payload : action.error.message || "Failed to export CSV";
      });
  },
});

export default ProjectManageTaksListSlice.reducer;
